module.exports = __webpack_public_path__ + "dz.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/dz.svg
// module id = 781
// module chunks = 0